import { COMPONENT_RELATIVELAYOUT } from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce Relative Layout Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function(name = "Relative Layout", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_RELATIVELAYOUT,
    children: children
  };
  return Object.assign(obj, common);
}
